export class FetchVenue {
    public static readonly type = '[Venue] FetchVenue';
    constructor(public gameId: string) { }
}

export class FetchVenueSurfaceConfig {
    public static readonly type = '[Venue] FetchVenueSurfaceConfig';
    constructor(public sport: string) { }
}
